import React, { useState, useEffect } from 'react'
import { Layout, message } from 'antd'
import styles from './Header.module.scss'
import Logo from 'assets/images/kiddy-logo.svg'

import { actionType } from 'reducers/auth'

import { logoutService } from 'api/auth'
import useAuth from 'context/auth'
import UserRightNav from './RightNav/UserRightNav'
import SchoolCollabUserRightNav from './RightNav/SchoolCollabUserRightNav'
import Search from '../Search/Search'
import ReactGA from 'react-ga'
import { TranslateLanguage } from 'util/Translate'
import { vocabHeaderCMS } from 'util/Translate.variable'

const translate = new TranslateLanguage()
translate.addMaping(vocabHeaderCMS)

const { Header } = Layout

const HeaderCMS = React.memo((props) => {
  const { user } = props
  const { dispatch } = useAuth()
  const path = props.location.pathname
  const goToProfile = () => {
    props.history.push('/profile')
  }
  const [searchValue, setSearchValue] = useState('')

  const handleSignOut = async () => {
    const res = await logoutService()
    if (res.error) return message.error(`ไม่สามารถออกจากระบบได้ ${res.error}`)
    dispatch({ type: actionType.LOGOUT })
    props.history.push('/login')
    ReactGA.event({
      category: 'User',
      action: 'logout',
      label: 'logout'
    })
  }

  useEffect(() => {
    if (props.location.pathname !== '/group/search') {
      setSearchValue('')
    }
  }, [props.location.pathname])

  const isUserSchoolCollab = () => user.schoolCollabName !== undefined

  const handleSearchGroup = (e) => {
    const { value } = e.target
    const check = value.split('qrCode=')
    if (check.length === 2) {
      setSearchValue('')
      return props.history.push(`/group/search?qrCode=${check[1]}`)
    }
    if (value) {
      props.history.push(`/group/search?query=${value}`)
    } else {
      props.history.push('/group')
    }
  }

  const handleChange = (e) => {
    const { value } = e.target
    setSearchValue(value)
  }

  return (
    <Header className={styles.header} >
      <div className={styles.divSearchBar}>
        <a href='/'>
          <img alt='logo' src={Logo} />
        </a>
      </div>
      {path.indexOf('group') > -1 ?
        <div className={styles.divSearch}>
          <Search size='large' placeholder={translate.convert('ค้นหากลุ่ม')} onSearch={handleSearchGroup} value={searchValue} handleChange={handleChange} />
        </div> :
        ''
      }

      {isUserSchoolCollab() ?
        <SchoolCollabUserRightNav user={user} onSignOut={handleSignOut} onProfile={goToProfile} props={props} />
        :
        <UserRightNav user={user} onSignOut={handleSignOut} onProfile={goToProfile} props={props} />
      }
    </Header>
  )
})

export default HeaderCMS